module.exports = __webpack_public_path__ + "static/media/VV.d396a0ad.webp";